export class ChangePasswordByAdmin {
    public userId: string;
    public newPassword: string;
    public newPasswordConf: string;
    public needSendToEmail: boolean;
}


// WEBPACK FOOTER //
// ./src/app/core/models/changePasswordByAdmin.model.ts